const flags = {
    'uncapped': 'Uncapped',
    'potentially-uncapped': 'Potentially Uncapped',
}

export const events = {
    flags,
};